<template>
  <div id="reports m">
    <no-multi-channel-service v-if="noEvidenceImage" />
    <div v-if="!noEvidenceImage">
      <div class="row m-t-xl">
        <div class="col-lg-6">
          <table class="table table-bordered bg-white">
            <tbody>
              <tr>
                <td class="product-report-item-title">商品レポート（Amazon倉庫）</td>
                <td class="text-center product-report-item-title">
                  <button
                    class="btn btn-primary w-254 btn-report-item-registed"
                    @click="openModalDownload('amazon')"
                  >
                    ダウンロード
                  </button>
                </td>
              </tr>
              <tr>
                <td class="product-report-item-title">商品レポート（STOCKCREW倉庫）</td>
                <td class="text-center product-report-item-title">
                  <button
                    class="btn btn-primary w-254 btn-report-item-registed"
                    @click="openModalDownload('sc')"
                  >
                    ダウンロード
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-6"></div>
      </div>
    </div>
    <product-download
      v-if="isShowDownload"
      :warehouseType="warehouseType"
      @close="closeModalDownload"
      @download="handleDownloadCsv()"
    />
  </div>
</template>
<script>
import ProductDownload from './ProductNewModalDownload.vue'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import NoMultiChannelService from '@/components/NoMultiChannelService'
import { mapGetters } from 'vuex'
import ProductService from '@/services/productservice'
import WarehouseScService from '@/services/warehousescservice'
import moment from 'moment'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ProductDownload,
    NoMultiChannelService
  },
  data () {
    return {
      isShowDownload: false,
      warehouseType: ''
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    }),
    noEvidenceImage () {
      return ['0', '9'].includes(this.userInfo.multiChannelSenderFlg)
    }
  },
  methods: {
    openModalDownload (warehouseType) {
      this.isShowDownload = true
      this.warehouseType = warehouseType
    },
    closeModalDownload () {
      this.isShowDownload = false
      $('#productDownload').modal('hide')
    },
    handleDownloadCsv () {
      this.closeModalDownload()
      let name = ''
      if (this.warehouseType === 'amazon') {
        name = eventCode.manage_products.report_tab.click_download_amazon_csv_button
        this.downloadCSV()
      }

      if (this.warehouseType === 'sc') {
        name = eventCode.manage_products.report_tab.click_download_sc_csv_button
        this.scDownloadCSV()
      }

      let logParams = {
        name: name,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },
    async downloadCSV () {
      let filename = this.getFileName()
      let params = {
        warehouseType: this.warehouseType
      }
      await ProductService.postRequestProductDownload(params, filename)
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    async scDownloadCSV () {
      let filename = this.getFileName()
      let params = {
        warehouseType: this.warehouseType
      }
      await WarehouseScService.downloadProductCSV(params, filename)
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    getFileName () {
      let sellerid = this.$store.getters.getUser.sellerId
      let reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      let filename = `salmon_${this.warehouseType}Products_${sellerid}_${reportTime}.csv`
      return filename
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'reports') {
      let logParams = {
        name: eventCode.manage_products.report_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/productsNew/Reports.vue